import React from 'react';
import { TabbedShowLayout, Tab, TextField, FunctionField, ReferenceField, ArrayField, useRecordContext } from 'react-admin';
import Box from '@mui/material/Box';

import Show, { ShowActions } from '../common/views/Show';
import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import MultilineTextField from '../common/fields/MultilineTextField';
import NumberCurrencyField from '../common/fields/NumberCurrencyField';
import InvoiceActionsButtons from './InvoiceActionsButtons';

import StatusField from './fields/StatusField';
import VatField from './fields/VatField';

import { API_URL } from '../../services/settings';

const iframeSx = {
    'iframe': {
        width: '100%',
        minHeight: '100vh',
        border: 'none'
    }
};

const InvoiceActions = (props) => (
    <ShowActions {...props} hasEdit={props?.data?.status === 'draft'}>
        <InvoiceActionsButtons record={props?.data} />
    </ShowActions>
);

const InvoicePDF = () => {
    const record = useRecordContext();

    return (
        <Box sx={iframeSx}>
            <iframe
                title="PDF"
                src={`${API_URL}/invoices/${record?.id}/invoice${record?.number ? `_${record.number}` : ''}.pdf?auth_token=${localStorage.getItem('token')}`}
            />
        </Box>
    );
};

const LineList = (props) => (
    <ArrayField {...props} source="lines">
        <Datagrid bulkActionButtons={false}>
            <MultilineTextField source="description" />
            <TextField source="qty" label="Quantity" />
            <FunctionField label="Price" render={record => <NumberCurrencyField record={{ currency: props?.record?.currency, ...record }} source="unit_price" />} />
            <VatField label="VAT" />
            <FunctionField label="Total excl. VAT" render={record => <NumberCurrencyField record={{ currency: props?.record?.currency, value: record.qty * record.unit_price }} source="value" />} />
        </Datagrid>
    </ArrayField>
);

const InvoiceShow = (props) => (
    <Show actions={<InvoiceActions />} {...props}>
        <TabbedShowLayout>
            <Tab label="PDF">
                <InvoicePDF />
            </Tab>
            <Tab label="Summary">
                <TextField label="Id" source="id" />
                <TextField source="number" />
                <StatusField label="Status" />
                <TextField source="source" />
                <ReferenceField label="Billing company" source="billing_company_id" reference="companies" allowEmpty>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="Customer" source="customer_id" reference="customers" allowEmpty>
                    <TextField source="name" />
                </ReferenceField>
                <ReferenceField label="Invoicing address" reference="addresses" source="invoicing_address_id" allowEmpty>
                    <FunctionField render={record => (
                        <>
                            {record.name}<br />
                            {record.street}<br />
                            {record.zipcode} {record.city}<br />
                            {record.country}<br />
                            {record.vat}
                        </>
                    )} />
                </ReferenceField>
                <TextField source="number" />
                <DateField source="invoiced_at" />
                <DateField source="due_date" />
                <TextField label="Customer Reference" source="purchase_order" />
                <LineList label={false} />
                <NumberCurrencyField source="total_untaxed" />
                <NumberCurrencyField source="total_tax" />
                <NumberCurrencyField source="total" />
                <MultilineTextField source="terms" />
                <MultilineTextField source="notes" />
                <DateField label="Created at" source="created_at" />
                <DateField label="Updated at" source="updated_at" />
            </Tab>
        </TabbedShowLayout>
    </Show>
);

export default InvoiceShow;
